module.exports = __webpack_public_path__ + "img/img84.86321bdf.png";